import { lazy } from "react";
import { userSVG } from '../shared/helpers/icons';

const EntryPoint = lazy(() => import( /* webpackChunkName: "contacts" */ './components/EntryPoint'));
const ContactsLoader = lazy(() => import( /* webpackChunkName: "contactsLoader" */ './components/ContactsLoader'));
const RouteFormContact = lazy(() => import( /* webpackChunkName: "routeFormContact" */ './components/RouteFormContact'));

export const defaultPath = '/contacts';

export const innerRoutes = [
    {
        path: `${defaultPath}/`,
        Component: ContactsLoader,
        exact: true,
        icon: userSVG,
        title: {
            key: '',
            plural: false
        },
        subTitle: {
            key: 'list_contacts',
            plural: false
        }
    },
    {
        path: `${defaultPath}/new`,
        Component: RouteFormContact,
        exact: true,
        icon: userSVG,
        title: {
            key: "",
            plural: false
        },
        subTitle: {
            key: 'create_new_contact',
            plural: false
        }
    },
    {
        path: `${defaultPath}/:id`,
        Component: RouteFormContact,
        exact: true,
        icon: userSVG,
        title: {
            key: "",
            plural: false
        },
        subTitle: {
            key: 'modification_contact',
            plural: false
        }
    }
];

const Contacts = {
    path: defaultPath,
    Component: EntryPoint,
    exact: false,
    icon: userSVG,
    title: {
        key: 'contacts',
        plural: false
    },
    subTitle: {
        key: 'list_contacts',
        plural: false
    },
    innerRoutes: innerRoutes,
    pathChilds: innerRoutes.map(e => e.path)
};

export default Contacts;
